import { Skeleton, Table, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { ApiService } from "api/api.service";
import { T_NestedChildrenUser } from "api/user.service";
import PageTitle from "components/PageTitle";
import { loaderSm, SingleQueryWrapper } from "components/QueryWrapper";
import { UserSchemaDto } from "dtos/user.dto";
import DashboardLayout from "layout/DashboardLayout";
import { TbLoader } from "react-icons/tb";
import { Link } from "react-router-dom";
import { formatMoney } from "utils/functions";

const columns: ColumnsType<T_NestedChildrenUser> = [
  {
    key: "name",
    dataIndex: "name",
    title: "Name",
    // width: 200,
    render: (_, record) => <Link to={`/dashboard/affiliate/${record._id}`}>{record.name}</Link>,
  },
  {
    key: "email",
    dataIndex: "email",
    title: "Email",
    // width: 200,
  },
  {
    key: "affiliate_code",
    dataIndex: "affiliate_code",
    title: "Affiliate Code",
    width: 130,
    render: (_, record) => {
      return record?.affiliate_code ?? "-";
    },
  },
  {
    key: "converted",
    dataIndex: "converted",
    title: "Converted",
    width: 90,
    render: (_, record) => {
      return (
        <div className="inline-flex">
          <Typography.Text className="font-medium">{record?.totalApplicationsConverted}</Typography.Text>
          <Typography.Text type="secondary">/{record?.totalApplications}</Typography.Text>
        </div>
      );
    },
  },

  // {
  //   key: "referrer_code",
  //   dataIndex: "referrer_code",
  //   title: "Lawsuits",
  //   width: 80,
  //   render: (_, record) => {
  //     return (
  //       <div className="inline-flex">
  //         <Typography.Text>{6}</Typography.Text>
  //       </div>
  //     );
  //   },
  // },
  // {
  //   key: "referrer_code",
  //   dataIndex: "referrer_code",
  //   title: "Total Commission",
  //   width: 80,
  //   render: (_, record) => {
  //     return (
  //       <div className="inline-flex">
  //         <Typography.Text>{formatMoney(105000)}</Typography.Text>
  //       </div>
  //     );
  //   },
  // },
  {
    key: "thisMonthCommission",
    dataIndex: "thisMonthCommission",
    title: "This Month Commission",
    width: 200,
    render: (_, record) => {
      return (
        <div className="inline-flex">
          <Typography.Text>
            {record?.thisMonthCommission ? formatMoney(record?.thisMonthCommission) : "-"}
          </Typography.Text>
        </div>
      );
    },
  },
  {
    key: "lastMonthCommission",
    dataIndex: "lastMonthCommission",
    title: "Last Month Commission",
    width: 200,
    render: (_, record) => {
      return (
        <div className="inline-flex">
          <Typography.Text>
            {record?.lastMonthCommission ? formatMoney(record?.lastMonthCommission) : "-"}
          </Typography.Text>
        </div>
      );
    },
  },
  // {
  //   title: "Ban Status",
  //   key: "is_banned",
  //   width: 80,
  //   render: (text, record) => <>{record.is_banned ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>}</>,
  // },
  // {
  //   title: "Action",
  //   dataIndex: "action",
  //   key: "action",
  //   width: 80,
  //   render: (name: string, record) => {
  //     return <Space>{/* <Button icon={<TbEdit />} type="text" onClick={() => openEditModal(record)} /> */}</Space>;
  //   },
  // },
];
export default function Affilites() {
  const affiliatesQuery = ApiService.user.useGetAffiliateHeirarchy();

  const statistics = affiliatesQuery?.data?.statistics;
  return (
    <DashboardLayout
      headerLeft={
        <Typography.Title level={5} className="!m-0">
          Affiliates
        </Typography.Title>
      }
      headerRight={
        affiliatesQuery.isLoading ? (
          <TbLoader className="animate-spin" />
        ) : (
          <Typography.Title level={5} className="!m-0">
            My Code: {affiliatesQuery.data?.data.affiliate_code ? affiliatesQuery.data?.data.affiliate_code : "-"}
          </Typography.Title>
        )
      }
    >
      <PageTitle title="Affiliates" pageTitle={[{ title: "Affiliates" }]} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 m-4">
        {[
          {
            label: statistics?.totalApplicationsConverted,
            subLabel: `/${statistics?.totalApplications}`,
            desc: "Successfully Converted Leads",
          },
          { label: formatMoney(statistics?.lastMonthCommission ?? 0), desc: "Last Month Earnings" },
          { label: formatMoney(statistics?.MTDCommission ?? 0), desc: "MTD Earnings" },
          { label: formatMoney(statistics?.thisMonthCommission ?? 0), desc: "This Month Earnings" },
          { label: formatMoney(statistics?.nextMonthCommission ?? 0), desc: "Min. Expected Next Month" },
        ].map((el) => {
          return (
            <div key={el.desc} className="p-4 rounded-lg border border-solid border-gray-200 flex flex-col gap-2">
              {affiliatesQuery?.data ? (
                <div className="inline-flex items-baseline">
                  <Typography.Title level={3} className="font-black !m-0">
                    {el.label}
                  </Typography.Title>
                  {el?.subLabel ? (
                    <Typography.Title level={4} type="secondary" className="font-extrabold !m-0">
                      {el.subLabel}
                    </Typography.Title>
                  ) : null}
                </div>
              ) : (
                <Skeleton.Button active />
              )}
              <Typography.Text type="secondary">{el.desc}</Typography.Text>
            </div>
          );
        })}
      </div>

      <Table<T_NestedChildrenUser>
        columns={columns}
        dataSource={affiliatesQuery?.data?.data ? [affiliatesQuery?.data?.data] : []}
        loading={{
          indicator: loaderSm,
          spinning: affiliatesQuery.isPending,
        }}
        pagination={false}
        rowKey={"_id"}
      />
    </DashboardLayout>
  );
}
